import React from "react";
import { AuthFormLayout } from "../../Layout";
import { connect } from "react-redux";
import { DashboardHeader } from "../../components/Header";
import language from "../../language";
import { VerifyOTP } from "../../components/MerchantVerification/Email";
import { withRouter } from "../../utils/withRouter";

class EmailVerificationsScreen extends React.Component {
  render() {
    return (
      <AuthFormLayout className="col-md-4">
        <VerifyOTP />
      </AuthFormLayout>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(withRouter(EmailVerificationsScreen));
